import React from 'react'

import { withStyles } from '@material-ui/core/styles'

import InputBase from '@material-ui/core/InputBase'

const SelectInput = withStyles(({ palette, spacing, shape }) => ({
  root: {
    padding: 0,
    marginTop: spacing(1),
    marginBottom: spacing(1),

    backgroundColor: palette.common.white,
    '--box-shadow-color': palette.trunkrs.grayscale.base,
    '--box-shadow-size': '1px',
    boxShadow: 'inset 0 0 0 var(--box-shadow-size) var(--box-shadow-color)',
    borderRadius: shape.borderRadius,
    '&:hover:not($disabled)': {
      backgroundColor: palette.common.white,
      '--box-shadow-color': palette.trunkrs.secondary.lightViolet.lightest,
      '--box-shadow-size': '2px',
    },
    '&$disabled': {
      backgroundColor: palette.trunkrs.grayscale.purgatory,
    },
  },
  adornedStart: {
    '& > svg:first-child': {
      position: 'absolute',
      width: 20,
      height: 20,
      marginLeft: spacing(2),
    },
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${spacing(2)}px`,
  },
  inputAdornedStart: {
    paddingLeft: `calc(20px + ${2 * spacing(2)}px) !important`,
  },
  disabled: {},
  focused: {
    '&:not($disabled)': {
      backgroundColor: palette.common.white,
      '--box-shadow-color': palette.trunkrs.secondary.lightViolet.base,
      '--box-shadow-size': '2px',
      borderRadius: shape.borderRadius,
      border: 'none',

      '& > div': {
        backgroundColor: 'transparent',
      },
    },
  },
}))(InputBase)

export default SelectInput
